import { IonButton, IonContent } from "@ionic/react";
import { AppHeader } from "../../components/Header/AppHeader";

const Calendar: React.FC = () => {
	return (
		<>
			<AppHeader title="Calendar" />
			<IonContent fullscreen className="ion-padding">
				<div className="container">
					<strong>Calendar</strong>
					<p>Page content</p>
				</div>
			</IonContent>
		</>
	);
};

export default Calendar;
